import { render, staticRenderFns } from "./PerformaceTable.vue?vue&type=template&id=7b0754dc&scoped=true&"
import script from "./PerformaceTable.vue?vue&type=script&lang=js&"
export * from "./PerformaceTable.vue?vue&type=script&lang=js&"
import style0 from "./PerformaceTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PerformaceTable.vue?vue&type=style&index=1&id=7b0754dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0754dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VPagination,VSimpleTable})
